<mat-progress-bar class="main-progress-loader" *ngIf="isLoading | async" [mode]="'indeterminate'"></mat-progress-bar>
<main class="main">
  <div class="main-content">
    <router-outlet></router-outlet>
  </div>
</main>
